import { useState, useCallback } from 'react';
import { trackingService } from '../services/trackingService';
import type { TrackingResponse, UseUserTrackingReturn } from '../types/tracking';

export function useUserTracking(): UseUserTrackingReturn {
  const [trackingData, setTrackingData] = useState<Map<string, TrackingResponse>>(new Map());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTracking = useCallback(async (userId: string, date: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await trackingService.getUserTracking(userId, date);
      setTrackingData(prev => {
        const next = new Map(prev);
        next.set(userId, data);
        return next;
      });
    } catch (err: any) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to load tracking data';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearTracking = useCallback(() => {
    setTrackingData(new Map());
    setError(null);
  }, []);

  return { trackingData, loading, error, fetchTracking, clearTracking };
}
